import { $fetch } from '@/services/axios';

export function fetch(params) {
  return $fetch(`operator/notices`, params);
}
